// SCREEN
@max-mobile: 759px;
@tablet: 760px;
@max-tablet: 1199px;
@desktop: 1200px;
@max-desktop: 1366px;

:root {
  --screen-max-mobile: @max-mobile;
  --screen-tablet: @tablet;
}

/* stylelint-disable @stylistic/property-case */

:export {
  desktopWidth: @desktop;
  mobileWidth: @max-mobile;
  tabletWidth: @tablet;
}
